import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';

import { DatePipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { locale, loadMessages } from "devextreme/localization";
import ptMessages from "devextreme/localization/messages/pt.json";
import config from 'devextreme/core/config';
import { environment } from '../environments/environment';

registerLocaleData(localePt, 'pt');

@Component({
  selector: 'hub-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent {
  constructor() {
    inject(ThemeService);

    loadMessages(ptMessages);
    locale(navigator.language);

    config({
      licenseKey: environment.devKey,
      defaultCurrency: 'BRL'
    });
  }
}
